import React from "react";
import CustomTable from "../../../../../../components/table/table";
import "../style.css";
import moment from "moment";

export default function View(props) {

  const getQualificationTypeName = (id) => {
    const type = (props.qualificationsData || []).find(q => q.id?.toString() === id?.toString());
    return type?.name || id;
  };

  const getQualificationName = (typeId, id) => {
    const type = (props.qualificationsData || []).find(q => q.id?.toString() === typeId?.toString());
    const qual = (type?.children_recursive || []).find(q => q.id?.toString() === id?.toString());
    return qual?.name || id;
  };

  const getStreamName = (typeId, qualId, id) => {
    const type = (props.qualificationsData || []).find(q => q.id?.toString() === typeId?.toString());
    const qual = (type?.children_recursive || []).find(q => q.id?.toString() === qualId?.toString());
    const stream = (qual?.children_recursive || []).find(q => q.id?.toString() === id?.toString());
    return stream?.name || id;
  };

  return (
    <div>
      <div className="view-container">
        <h6>
          <b>Basic Details</b>
        </h6>

        <hr />

        <div className="data">
          <div className="row">
            <div className="col-3">Institution</div>
            <div className="col-1">:</div>
            <div className="col-7">{props.basicData.institution_name ?? ""}</div>
          </div>
          <div className="row">
            <div className="col-3">Full Name</div>
            <div className="col-1">:</div>
            <div className="col-7">{props.basicData.full_name ?? ""}</div>
          </div>
          <div className="row">
            <div className="col-3">Email Address</div>
            <div className="col-1">:</div>
            <div className="col-7">{props.basicData.email ?? ""}</div>
          </div>
          <div className="row">
            <div className="col-3">Phone Number</div>
            <div className="col-1">:</div>
            <div className="col-7">{props.basicData.phone_no ?? ""}</div>
          </div>
          <div className="row">
            <div className="col-3">Date of Birth</div>
            <div className="col-1">:</div>
            <div className="col-7">
              {props.basicData.date_of_birth
                ? moment(props.basicData.date_of_birth, "DD-MM-YYYY").format(
                  "DD-MM-YYYY"
                )
                : ""}
            </div>
          </div>
          <div className="row">
            <div className="col-3">Gender</div>
            <div className="col-1">:</div>
            <div className="col-7">{props.basicData.gender ?? ""}</div>
          </div>
          <div className="row">
            <div className="col-3">Kerala Native</div>
            <div className="col-1">:</div>
            <div className="col-7">{props.basicData.is_kerala_native ? "Yes" : "No"}</div>
          </div>
          <div className="row">
            <div className="col-3">Course Completion</div>
            <div className="col-1">:</div>
            <div className="col-7" style={{ textTransform: 'capitalize' }}>{props.basicData.course_completion_status}</div>
          </div>
          <div className="row">
            <div className="col-3">Address</div>
            <div className="col-1">:</div>
            <div className="col-7">{props.basicData.address}</div>
          </div>

          <div className="row mt-3">
            <div className="col-12">
              <h6><b>Educational Qualification</b></h6>
              {props.basicData?.qualifications?.map((qual, idx) => (
                <div key={idx} className="mb-4 p-3 border rounded">
                  <div className="row mb-2">
                    <div className="col-4"><b>Type:</b> {getQualificationTypeName(qual.qualification_type_id)}</div>
                    <div className="col-4"><b>Qualification:</b> {getQualificationName(qual.qualification_type_id, qual.qualification_id)}</div>
                    {qual.stream_id && (
                      <div className="col-4"><b>Stream:</b> {getStreamName(qual.qualification_type_id, qual.qualification_id, qual.stream_id)}</div>
                    )}
                  </div>
                  <div className="row mb-2">
                    <div className="col-4"><b>Board:</b> {qual.board}</div>
                    <div className="col-4"><b>Year:</b> {qual.year_passed}</div>
                    <div className="col-4"><b>Mark System:</b> {qual.mark_system === 'semester_gpa' ? 'Semester GPA' : 'Percentage'}</div>
                  </div>

                  <div className="mt-2">
                    <h6>Marks Breakdown</h6>
                    <div className="table-responsive rounded-3 overflow-hidden border mt-2">
                      <table className="table table-sm table-hover mb-0">
                        <thead className="bg-light text-uppercase">
                          <tr style={{ fontSize: '11px', letterSpacing: '0.5px' }}>
                            <th className="px-3 py-2 border-0 fw-bold text-secondary">Period</th>
                            {qual.mark_system === 'semester_gpa' ? (
                              <th className="py-2 border-0 fw-bold text-secondary text-center">CGPA</th>
                            ) : (
                              <>
                                <th className="py-2 border-0 fw-bold text-secondary text-center">Marks Obtained</th>
                                <th className="py-2 border-0 fw-bold text-secondary text-center">Total Marks</th>
                              </>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {qual.marks?.map((m, mIdx) => (
                            <tr key={mIdx} className="align-middle border-top">
                              <td className="px-3 py-2 fw-bold text-dark small">{m.period_type === 'semester' ? `Semester ${m.period_number}` : `Year ${m.period_number}`}</td>
                              {qual.mark_system === 'semester_gpa' ? (
                                <td className="py-2 text-center text-dark fw-bold small">{m.cgpa}</td>
                              ) : (
                                <>
                                  <td className="py-2 text-center text-dark small">{m.marks_obtained}</td>
                                  <td className="py-2 text-center text-dark small">{m.total_marks}</td>
                                </>
                              )}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="mt-2">
                    <b>Certificate:</b>{" "}
                    {qual.certificate_photo instanceof File ? (
                      <a href={URL.createObjectURL(qual.certificate_photo)} target="_blank" rel="noreferrer" className="text-primary text-decoration-underline">
                        {qual.file_name}
                      </a>
                    ) : qual.certificate_photo ? (
                      <a href={typeof qual.certificate_photo === 'string' && qual.certificate_photo.startsWith('http') ? qual.certificate_photo : `${process.env.REACT_APP_BASE_URL.replace('/api/', '')}/${qual.certificate_photo}`} target="_blank" rel="noreferrer" className="text-primary text-decoration-underline">
                        {qual.file_name || "View Certificate"}
                      </a>
                    ) : (
                      qual.file_name || "N/A"
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-3">Languages Known</div>
            <div className="col-1">:</div>
            <div className="col-7">
              <div className="d-flex flex-wrap gap-2">
                {props.basicData?.languages?.map((lang, i) => (
                  <span key={i} className="badge bg-light text-dark border">{lang.language}</span>
                ))}
              </div>
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-12">
              <h6><b>Internship Proposals (Selected {props.basicData?.proposals?.length})</b></h6>
              <div className="list-group">
                {props.basicData?.proposals?.map((prop, i) => {
                  const opportunity = (props.internshipOpportunities || []).find(o => o.id?.toString() === prop.internship_request_id?.toString());
                  return (
                    <div key={i} className="list-group-item d-flex justify-content-between align-items-center">
                      <div>
                        <strong>#{prop.preference_order}</strong> — {opportunity ? opportunity.internship_discipline : `Opportunity ID: ${prop.internship_request_id}`}
                        {opportunity?.brief_description && (
                          <><br /><small className="text-muted">{opportunity.brief_description}</small></>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-3">Photo</div>
            <div className="col-1">:</div>
            <div className="col-7">
              {props.basicData.photo instanceof File ? (
                <a href={URL.createObjectURL(props.basicData.photo)} target="_blank" rel="noreferrer" className="text-primary text-decoration-underline">
                  {props.basicData.file_name}
                </a>
              ) : props.basicData.file_upload_photo ? (
                <a href={props.basicData.file_upload_photo} target="_blank" rel="noreferrer" className="text-primary text-decoration-underline">
                  {props.basicData.file_name || "View Photo"}
                </a>
              ) : (
                props.basicData.file_name ?? "N/A"
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-3">Recommendation Letter</div>
            <div className="col-1">:</div>
            <div className="col-7">
              {props.basicData.rec_letter instanceof File ? (
                <a href={URL.createObjectURL(props.basicData.rec_letter)} target="_blank" rel="noreferrer" className="text-primary text-decoration-underline">
                  {props.basicData.rec_letter_name}
                </a>
              ) : props.basicData.rec_letter && typeof props.basicData.rec_letter === 'string' ? (
                <a href={props.basicData.rec_letter.startsWith('http') ? props.basicData.rec_letter : `${process.env.REACT_APP_BASE_URL.replace('/api/', '')}/${props.basicData.rec_letter}`} target="_blank" rel="noreferrer" className="text-primary text-decoration-underline">
                  {props.basicData.rec_letter_name || "View Letter"}
                </a>
              ) : (
                props.basicData.rec_letter_name ?? "N/A"
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-3">Resume</div>
            <div className="col-1">:</div>
            <div className="col-7">
              {props.basicData.resume instanceof File ? (
                <a href={URL.createObjectURL(props.basicData.resume)} target="_blank" rel="noreferrer" className="text-primary text-decoration-underline">
                  {props.basicData.resume_name}
                </a>
              ) : props.basicData.resume && typeof props.basicData.resume === 'string' ? (
                <a href={props.basicData.resume.startsWith('http') ? props.basicData.resume : `${process.env.REACT_APP_BASE_URL.replace('/api/', '')}/${props.basicData.resume}`} target="_blank" rel="noreferrer" className="text-primary text-decoration-underline">
                  {props.basicData.resume_name || "View Resume"}
                </a>
              ) : (
                props.basicData.resume_name ?? "N/A"
              )}
            </div>
          </div>
        </div>

        <div className="footer-buttons mt-3 pb-4">
          <button
            type="button"
            className="secondary-btn"
            onClick={(e) => {
              e.preventDefault();
              props.action(1);
            }}
          >
            GO BACK
          </button>
          <button
            type="button"
            className="primary-btn"
            onClick={(e) => {
              e.preventDefault();
              props.action(2);
            }}
          >
            REGISTER
          </button>
        </div>
      </div>
    </div>
  );
}
